import { useSyncExternalStore } from "react";
import { getConsentSnapshot, getServerConsentSnapshot, subscribeToConsent } from "./controller";
export function useConsentSnapshot() {
  return useSyncExternalStore(subscribeToConsent, getConsentSnapshot, getServerConsentSnapshot);
}
export function useIubendaPreferences() {
  return useConsentSnapshot().preferences;
}